import { atom } from 'jotai';
import { RestaurantItem } from '@restaurant/types';

let _restaurantId: string | null = null;

export const restaurantAtom = atom<RestaurantItem | null>(null);

export const selectRestaurantShowAtom = atom(false);

const restaurantStore = {
  setRestaurantId(val: string) {
    _restaurantId = val;
  },
  getRestaurantId() {
    return _restaurantId;
  },
};

export default restaurantStore;
